/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CurrencyModel } from '../../models/currency-model';

export interface GetApiCurrencyV1Id$Plain$Params {

/**
 * The unique identifier of the currency to retrieve.
 */
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
}

export function getApiCurrencyV1Id$Plain(http: HttpClient, rootUrl: string, params: GetApiCurrencyV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CurrencyModel>>> {
  const rb = new RequestBuilder(rootUrl, getApiCurrencyV1Id$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CurrencyModel>>;
    })
  );
}

getApiCurrencyV1Id$Plain.PATH = '/private/v1/currencies/{id}';
